import React from "react";
import { Container, Stack } from "@mui/material";
import OrderHistoryView from "../components/OrderHistoryView";

export default function OrderHistoryPage() {
  return (
    <Container sx={{ py: 4 }}>
      <Stack spacing={3}>
        <OrderHistoryView />
      </Stack>
    </Container>
  );
}
